<div class="boxWhite">

  <div class="headInfo">
    <div class="infoVcb">

      <div class="boxViaje" (click)="navigateToViaje()" style="cursor: pointer;">
        <div class="ico">
          <img src="assets/img/icoInfo.svg" alt="">
        </div>
        <div class="servicio">
          <span>SERVICIO</span>
          <h4>{{ viajeSeleccionado.servicio }}</h4>
        </div>
        <div class="item">
          <span>DESTINO</span>
          <p>{{ viajeSeleccionado.sucursalDestino?.nombre }}</p>
        </div>
        <div class="item">
          <span>INICIO</span>
          <p>{{ viajeSeleccionado.fechahoraInicio | date:'HH:mm' }}</p>
        </div>
        <div class="item">
          <span>DURACIÓN</span>
          <p>--</p>
        </div>
        <div class="item">
          <span>TIPO CONTRATO</span>
          <p>{{ viajeSeleccionado.contratoCodigo }}</p>
        </div>
        <div class="item">
          <span>ESTADO</span>
          <p>{{ viajeSeleccionado.estado }}</p>
        </div>

      </div>

      <div class="cbActual">
        <div class="item">
          <span>ID CONDUCTOR</span>
          <p>{{ viajeSeleccionado?.conductor?.visibleId || 'No asignado' }}</p>
        </div>
        <div class="item">
          <span>NOMBRE CONDUCTOR</span>
          <p>{{ viajeSeleccionado?.conductor?.nombres || 'No asignado' }}</p>
        </div>
        <div class="item">
          <span>TERMINAL CONTRATO</span>
          <p>{{ viajeSeleccionado?.conductor?.contratoSucursal?.nombre || 'No asignado' }}</p>
        </div>
        <div class="item mt-2">
          <button class="btn btnOrange" (click)="toggleReemplazo()" *ngIf="!showReemplazo && selectedConductor">
            Mostrar reemplazo
          </button>
        </div>
      </div>
    </div>

    <div class="reemplazo" *ngIf="showReemplazo && selectedConductor">
      <button class="btn btnClose" (click)="closeReemplazo()">
        <img src="assets/img/icoClose.svg" alt="">
      </button>
      <div class="groupItems">
        <div class="item">
          <span>NOMBRE CONDUCTOR</span>
          <p>{{ selectedConductor.nombres }} {{ selectedConductor.apellidoPaterno }}</p>
        </div>
        <div class="item">
          <span>ESTADO</span>
          <p class="clBlue">{{ selectedConductor.estado || 'Disponible' }}</p>
        </div>
        <div class="item">
          <span>CELULAR</span>
          <p>{{ selectedConductor.celular || 'No disponible' }}</p>
        </div>
      </div>
      <button *ngIf="!asignandoConductor && tienePermisoAsignarConductor()"
      class="btn btnOrange w-100"
      [disabled]="isViajeEnCurso"
      (click)="asignarConductor()">
      ASIGNAR</button>

      <button *ngIf="asignandoConductor && tienePermisoAsignarConductor()" class="btn btnOrange w-100" >
      ASIGNANDO...</button>
    </div>
  </div>


  <div class="headBox">
    <div class="filtros">
      <div class="buscar itemForm">
        <input type="search" class="form-control" placeholder="Buscar..." 
               [ngModel]="searchText" 
               (ngModelChange)="onSearchChange($event)">
      </div>
    </div>
  </div>

  <!-- Initial loading indicator only shown when no data is available yet -->
  <div *ngIf="loading && filteredConductores.length === 0" class="text-center p-3">
    <p>Cargando conductores...</p>
  </div>

  <div *ngIf="error" class="alert alert-danger m-3">
    {{ error }}
  </div>

  <!-- Table is always visible once data is loaded, regardless of loading state -->
  <div class="tableResp" *ngIf="filteredConductores.length > 0 || (!loading && !error)"
       infiniteScroll 
       [infiniteScrollDistance]="1" 
       [infiniteScrollThrottle]="50" 
       (scrolled)="onScroll()"
       [scrollWindow]="false" 
       [infiniteScrollDisabled]="loading || desactivarInfiniteScroll">
    <table class="table">
      <thead>
      <tr>
        <th (click)="onSort('visibleId')" style="cursor: pointer;">
          ID
          <span *ngIf="orderBy === 'visibleId'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
        </th>
        <th (click)="onSort('nombres')" style="cursor: pointer;">
          NOMBRE
          <span *ngIf="orderBy === 'nombres'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
        </th>
        <th (click)="onSort('estado')" style="cursor: pointer;">
          ESTADO
          <span *ngIf="orderBy === 'estado'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
        </th>
        <th>
          HORA DE LLEGADA
        </th>
        <th>
          ADJ
        </th>
        <th>
          H. DISPONIBLES
        </th>
        <th>
          H.E.
        </th>
        <th (click)="onSort('nombre')" style="cursor: pointer;">
          TERMINAL ACTUAL
          <span *ngIf="orderBy === 'nombre'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
        </th>
        <th>ACCIÓN</th>
      </tr>
      </thead>


      <tbody>
      <tr *ngIf="filteredConductores.length === 0">
        <td colspan="9" class="text-center">
          {{ searchText ? 'No se encontraron conductores que coincidan con la búsqueda' : responseMsg }}
        </td>
      </tr>
      
      <tr *ngFor="let conductor of filteredConductores; let i = index" 
          [class.selected]="i === selectedIndex"
          [ngClass]="{
            'bgRed': estaHaciendoHorasExtras(conductor),
            'bgYellow': !estaHaciendoHorasExtras(conductor) && cercanoATerminarJornada(conductor)
          }"
          (click)="selectConductor(conductor, i)"
          [style.cursor]="isViajeEnCurso || (conductor.estado && conductor.estado !== 'DISPONIBLE') ? 'not-allowed' : 'pointer'"
          [class.disabled-row]="isViajeEnCurso || (conductor.estado && conductor.estado !== 'DISPONIBLE')">
        <td>{{ conductor.visibleId }}</td>
        <td>{{ conductor.nombres }} {{ conductor.apellidoPaterno }}</td>
        <td><span class="clBlue">{{ conductor.estado || 'Disponible' }}</span></td>
        <td>{{ getTiempoLlegada(conductor) }}</td>
        <td>{{ conductor.adj ? 'Si' : 'No' }}</td>
        <td>{{ getHorasDisponibles(conductor) }}</td>
        <td>{{ getHorasExtras(conductor) }}</td>
        <td>{{ (conductor.sucursalActual?.nombre) || 'No especificado' }}</td>
        <td>
          <div class="btns">
            <button class="btn btnVer" (click)="viewConductorDetails(conductor, $event)"><img src="assets/img/icoVer.svg" alt=""></button>
          </div>
        </td>
      </tr>
      </tbody>

    </table>
  </div>

</div>
